import { Divider, Grid2, Skeleton } from "@mui/material"
import { memo } from "react"

const LiveChatSkeleton = memo(() => {
    return (
        <Grid2 container spacing={2} flexDirection={{ xs: 'column', md: 'row' }}>
            <Grid2 container size={'auto'} flexDirection={{ xs: 'row', md: 'column' }} bgcolor={'rgba(0,0,0,0.05)'} borderRadius={4} padding={2} justifyContent={'center'} alignItems={'start'} gap={1} height={'100%'} maxWidth={'70vw'} maxHeight={'75vh'} overflow={'auto'} wrap="nowrap">
                <Grid2 paddingX={3}>
                    <Skeleton variant="circular" width={50} height={50} />
                </Grid2>
                <Grid2 paddingX={3}>
                    <Skeleton variant="circular" width={50} height={50} />
                </Grid2>
                <Grid2 paddingX={3}>
                    <Skeleton variant="circular" width={50} height={50} />
                </Grid2>
                <Grid2 paddingX={3}>
                    <Skeleton variant="circular" width={50} height={50} />
                </Grid2>
            </Grid2>
            <Grid2 container size={'grow'} minHeight={'60vh'} maxHeight={{ xs: '65vh', md: '75vh', lg: '85vh' }} wrap="nowrap" sx={{ overflowY: 'auto', overflowX: 'hidden' }} flexDirection={'column'} bgcolor={'rgba(0,0,0,0.05)'} borderRadius={4} padding={2} spacing={2}>
                <Grid2 paddingX={3}>
                    <Skeleton variant="text" sx={{ fontSize: '3rem' }} />
                </Grid2>
                <Divider flexItem />
                <Grid2 paddingX={2}>
                    <Skeleton variant="rounded" width={100} height={40} sx={{ borderRadius: 50 }} />
                </Grid2>
                <Grid2 paddingX={2}>
                    <Skeleton variant="rounded" width={150} height={40} sx={{ borderRadius: 50 }} />
                </Grid2>
                <Grid2 paddingX={2} display={'flex'} justifyContent={'end'}>
                    <Skeleton variant="rounded" width={200} height={40} sx={{ borderRadius: 50 }} />
                </Grid2>
                <Grid2 paddingX={2}>
                    <Skeleton variant="rounded" width={80} height={40} sx={{ borderRadius: 50 }} />
                </Grid2>
                <Grid2 paddingX={2} display={'flex'} justifyContent={'end'}>
                    <Skeleton variant="rounded" width={230} height={40} sx={{ borderRadius: 50 }} />
                </Grid2>
                <Grid2 paddingX={2} display={'flex'} justifyContent={'end'}>
                    <Skeleton variant="rounded" width={120} height={40} sx={{ borderRadius: 50 }} />
                </Grid2>
                <Grid2 paddingX={2}>
                    <Skeleton variant="rounded" width={120} height={40} sx={{ borderRadius: 50 }} />
                </Grid2>
                <Grid2 paddingX={2}>
                    <Skeleton variant="rounded" width={180} height={40} sx={{ borderRadius: 50 }} />
                </Grid2>
                <Grid2 paddingX={2} display={'flex'} justifyContent={'end'}>
                    <Skeleton variant="rounded" width={180} height={40} sx={{ borderRadius: 50 }} />
                </Grid2>
                <Grid2 size={'grow'} />
                <Grid2 paddingX={3}>
                    <Skeleton variant="text" sx={{ fontSize: '3rem' }} />
                </Grid2>
            </Grid2>

        </Grid2>
    )
})

export default LiveChatSkeleton